import { type ReactNode } from 'react'
import { useQueryDisclosure } from '@hooks'
import { Tooltip } from '@mantine/core'
import { type PermissionType, type PermissionListItem } from '@terros/common'
import { TButton } from '../buttons'
import { PermissionAuditDrawer } from './PermissionAuditDrawer'

type Props = {
  permissionType: PermissionType
  permissionInfo: PermissionListItem
}

export const HistoryButton = ({ permissionType, permissionInfo }: Props): ReactNode => {
  const [opened, { open, close }] = useQueryDisclosure(permissionType, false)

  return (
    <div className='ml-auto'>
      <Tooltip label='History'>
        <TButton buttonType='icon-rounded' icon='history' variant='secondary' onClick={open} />
      </Tooltip>
      <PermissionAuditDrawer
        close={close}
        opened={opened}
        permissions={permissionInfo}
        permissionType={permissionType}
      />
    </div>
  )
}
